import React from "react"
import styled from "@emotion/styled"
import { FetchMenusQuery } from "apollo"
import SideMenu, { StyledButton, StyledLink } from "layout/SideMenu"
import Image from "next/image"
import PazChargeLogo from "public/icons/pazCharge/Logo/Logo.svg"
import { useState } from "react"
import MobileHeaderCharge from "./MobileHeaderCustom"

const StyledRelative = styled.header`
  position: relative;
  z-index: 30;
  @media print {
    display: none;
  }
`
const StyledHeader = styled.div<{ isOpen: boolean }>`
  position: fixed;
  z-index: 100001;
  top: 0px;
  left: 0px;
  width: 100%;
  background-color: ${(props) => props.theme.colors.white};
  display: flex;
  height: 64px;
  align-items: center;
  box-sizing: border-box;
  padding: 0 16px;
  box-shadow: ${(props) =>
    !props.isOpen ? "0px 2px 8px 0px rgba(130, 136, 148, 0.25)" : null};

  @media (min-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    height: 98px;
    padding: 0;
  }
`
// StyledLink
const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: auto;
  align-items: center;
  padding: 0;
  position: relative;
  @media (min-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    padding: 0 60px;
  }
`
const StyledWrapperButton = styled(StyledButton)`
    position: absolute;
    top: 5px;
    left: -5px;
`
function MobileMenuCharge({
  data,
}: {
  data: FetchMenusQuery
}) {
  const [open, setOpen] = useState<boolean>(false)
  return (
    <StyledRelative role="banner">
      <MobileHeaderCharge open={open} setOpen={setOpen} href="/pazcharge" logo="/icons/pazCharge/Logo/Logo.svg" />
      <SideMenu
        menuItems={data}
        open={open}
        setOpen={setOpen}
        hrefValue={""}
        showSelectLanguage={false}
        withButtonAtEnd={true}
      />
    </StyledRelative>
  )
}
export default MobileMenuCharge
